import { createFileRoute } from '@tanstack/react-router';

import { TemplateEditorPage } from '@/features/admin/assessments/TemplateEditorPage';

function NewTemplateRoute() {
  return <TemplateEditorPage />;
}

export const Route = createFileRoute('/_authed/admin/assessments/new')({
  component: NewTemplateRoute,
});
